var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 166,
    viewBox: "0 0 112 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2648 61.0987C34.2648 61.0987 22.4397 113.019 0.356426 150.64L24.9724 143.756L35.9081 166C35.9081 166 62.7943 122.05 67.5887 71.7454L34.2648 61.0987Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0916 61.0987C78.0916 61.0987 89.9252 113.019 112 150.64L87.384 143.756L76.4567 166C76.4567 166 49.5621 122.05 44.7762 71.7454L78.0916 61.0987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9084 60.7452C33.9084 60.7452 22.0832 112.666 0 150.287L24.616 143.394L35.5517 165.646C35.5517 165.646 62.4379 121.696 67.2323 71.3919L33.9084 60.7452Z",
    fill: "url(#paint0_linear_3647_7393)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9084 60.7452C33.9084 60.7452 22.0832 112.666 0 150.287L24.616 143.394L35.5517 165.646C35.5517 165.646 62.4379 121.696 67.2323 71.3919L33.9084 60.7452Z",
    fill: "url(#paint1_linear_3647_7393)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7365 60.7457C77.7365 60.7457 89.5701 112.666 111.645 150.287L87.0289 143.394L76.1016 165.647C76.1016 165.647 49.207 121.697 44.421 71.3924L77.7365 60.7457Z",
    fill: "url(#paint2_linear_3647_7393)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7365 60.7457C77.7365 60.7457 89.5701 112.666 111.645 150.287L87.0289 143.394L76.1016 165.647C76.1016 165.647 49.207 121.697 44.421 71.3924L77.7365 60.7457Z",
    fill: "url(#paint3_linear_3647_7393)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.5137 139.203L7.24273 144.589C23.6675 113.651 33.5529 77.0145 36.4753 65.2737L63.3953 73.8837C59.2023 111.21 42.8114 144.934 35.7637 158.039L26.5137 139.203Z",
    fill: "url(#paint4_linear_3647_7393)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.882 158.039C68.8343 144.934 52.4519 111.21 48.2504 73.8838L75.1704 65.2738C78.1013 77.0146 87.9867 113.651 104.411 144.589L85.132 139.203L75.882 158.039Z",
    fill: "url(#paint5_linear_3647_7393)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1596 11.5017C39.5751 9.73422 39.0584 6.90632 41.3031 4.15418C43.641 1.30104 45.2928 1.1243 46.8091 1.0738C48.4355 1.0233 49.291 8.48859 49.291 8.48859L56.8639 51.1763C56.8639 51.1763 43.5055 21.7275 40.1596 11.5017Z",
    fill: "url(#paint6_linear_3647_7393)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4759 14.986C32.595 13.3448 31.5869 10.6516 33.3234 7.55435C35.1192 4.33931 36.7202 3.88482 38.2026 3.57342C39.8036 3.23676 41.9467 10.4496 41.9467 10.4496L56.8639 51.1763C56.8639 51.1763 38.5584 24.4796 33.4759 14.986Z",
    fill: "url(#paint7_linear_3647_7393)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5045 19.5729C26.3525 18.1085 24.887 15.6256 26.056 12.2844C27.2673 8.80841 28.7582 8.07618 30.1643 7.51228C31.6806 6.91473 35.0519 13.6394 35.0519 13.6394L56.8639 51.1763C56.8639 51.1763 34.171 28.0397 27.5045 19.5729Z",
    fill: "url(#paint8_linear_3647_7393)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4298 25.1192C21.0406 23.8736 19.1601 21.6854 19.7277 18.1842C20.3121 14.5567 21.6505 13.5804 22.9465 12.7809C24.3273 11.9308 28.8252 17.9738 28.8252 17.9738L56.8639 51.1763C56.8639 51.1763 30.477 32.3068 22.4298 25.1192Z",
    fill: "url(#paint9_linear_3647_7393)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3997 31.457C16.8156 30.4723 14.5794 28.6376 14.5285 25.0943C14.4692 21.4163 15.6213 20.2296 16.7479 19.2197C17.9677 18.134 23.4482 23.3184 23.4482 23.3184L56.8653 51.1765C56.8653 51.1765 27.582 37.1465 18.3997 31.457Z",
    fill: "url(#paint10_linear_3647_7393)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5355 38.3921C13.799 37.6935 11.2832 36.2711 10.614 32.7952C9.91095 29.1846 10.8343 27.8127 11.7745 26.626C12.7825 25.3552 19.0848 29.5044 19.0848 29.5044L56.8639 51.1763C56.8639 51.1763 25.5734 42.4151 15.5355 38.3921Z",
    fill: "url(#paint11_linear_3647_7393)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9247 45.7143C12.0951 45.3272 9.36747 44.3593 8.09686 41.0601C6.78389 37.6178 7.45308 36.1113 8.16463 34.7815C8.93546 33.3507 15.873 36.3469 15.873 36.3469L56.8629 51.1765C56.8629 51.1765 24.5132 47.9447 13.9247 45.7143Z",
    fill: "url(#paint12_linear_3647_7393)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6303 53.2049C11.7582 53.1375 8.9036 52.6578 7.07392 49.6195C5.17647 46.4634 5.57459 44.8643 6.04048 43.4251C6.54873 41.8849 13.9013 43.6523 13.9013 43.6523L56.8653 51.1765C56.8653 51.1765 24.439 53.5752 13.6303 53.2049Z",
    fill: "url(#paint13_linear_3647_7393)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6377 60.6362C12.7911 60.8887 9.89407 60.9139 7.55614 58.2375C5.13351 55.4517 5.24363 53.8105 5.46387 52.3124C5.69258 50.7133 13.24 51.1762 13.24 51.1762L56.8639 51.1763C56.8639 51.1763 25.3532 59.1297 14.6377 60.6362Z",
    fill: "url(#paint14_linear_3647_7393)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9331 67.7732C15.1542 68.3455 12.308 68.8673 9.54657 66.637C6.66652 64.314 6.48863 62.6729 6.4378 61.1663C6.38698 59.542 13.9005 58.7004 13.9005 58.7004L56.8639 51.1763C56.8639 51.1763 27.225 64.4487 16.9331 67.7732Z",
    fill: "url(#paint15_linear_3647_7393)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4405 74.4137C18.7887 75.289 16.0781 76.2821 12.9609 74.5652C9.7335 72.7725 9.2676 71.1902 8.95419 69.7173C8.61536 68.1266 15.8748 65.9973 15.8748 65.9973L56.8647 51.1761C56.8647 51.1761 29.9955 69.3554 20.4405 74.4137Z",
    fill: "url(#paint16_linear_3647_7393)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0561 80.3472C23.5822 81.4834 21.0833 82.9394 17.7204 81.7864C14.222 80.5828 13.485 79.0931 12.9175 77.696C12.3161 76.1895 19.0842 72.8482 19.0842 72.8482L56.8639 51.1763C56.8639 51.1763 33.5777 73.7151 25.0561 80.3472Z",
    fill: "url(#paint17_linear_3647_7393)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6401 85.3885C29.3864 86.7688 27.184 88.6288 23.6687 88.0734C20.0093 87.4926 19.0267 86.1544 18.222 84.8752C17.3664 83.5033 23.4484 79.0342 23.4484 79.0342L56.8653 51.1765C56.8653 51.1765 37.8741 77.393 30.6401 85.3885Z",
    fill: "url(#paint18_linear_3647_7393)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0183 89.3947C36.0272 90.9686 34.1806 93.1821 30.6144 93.241C26.9127 93.2999 25.7183 92.1553 24.7018 91.0275C23.6176 89.824 28.8271 84.3786 28.8271 84.3786L56.8653 51.1765C56.8653 51.1765 42.7445 80.2714 37.0183 89.3947Z",
    fill: "url(#paint19_linear_3647_7393)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9977 92.2395C43.2947 93.9564 41.8631 96.456 38.3647 97.1294C34.7307 97.8195 33.35 96.9021 32.1556 95.9679C30.8765 94.9748 35.0526 88.713 35.0526 88.713L56.8647 51.1761C56.8647 51.1761 48.0467 82.2661 43.9977 92.2395Z",
    fill: "url(#paint20_linear_3647_7393)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3673 93.8302C50.9777 95.6481 50.0036 98.3581 46.683 99.6206C43.2185 100.934 41.7022 100.269 40.3638 99.5533C38.9238 98.7958 41.9394 91.9028 41.9394 91.9028L56.8647 51.1761C56.8647 51.1761 53.6121 83.3097 51.3673 93.8302Z",
    fill: "url(#paint21_linear_3647_7393)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.906 94.1331C58.8383 95.9847 58.3554 98.8295 55.2975 100.639C52.121 102.533 50.5115 102.137 49.0715 101.666C47.5214 101.161 49.2917 93.8554 49.2917 93.8554L56.8647 51.1761C56.8647 51.1761 59.2787 83.3855 58.906 94.1331Z",
    fill: "url(#paint22_linear_3647_7393)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3857 93.1316C66.6483 94.9664 66.6652 97.8447 63.9715 100.159C61.1677 102.566 59.5159 102.457 58.0081 102.247C56.3987 102.019 56.8646 94.5203 56.8646 94.5203L56.8647 51.1761C56.8647 51.1761 64.8694 82.4849 66.3857 93.1316Z",
    fill: "url(#paint23_linear_3647_7393)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5701 90.8423C74.1545 92.6098 74.6713 95.4461 72.4265 98.1898C70.0886 101.043 68.4368 101.22 66.9205 101.27C65.2941 101.329 64.4386 93.8554 64.4386 93.8554L56.8658 51.1761C56.8658 51.1761 70.2241 80.6249 73.5701 90.8423Z",
    fill: "url(#paint24_linear_3647_7393)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2535 87.3664C81.1344 88.9992 82.1425 91.7008 80.406 94.7896C78.6017 98.0047 77.0092 98.4675 75.5268 98.7789C73.9258 99.1072 71.7827 91.9028 71.7827 91.9028L56.8658 51.1761C56.8658 51.1761 75.1626 77.8728 80.2535 87.3664Z",
    fill: "url(#paint25_linear_3647_7393)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2169 82.7795C87.3774 84.2355 88.8343 86.7268 87.6739 90.0681C86.4625 93.544 84.9717 94.2678 83.5571 94.8317C82.0493 95.4377 78.6779 88.713 78.6779 88.713L56.8658 51.1761C56.8658 51.1761 79.5504 74.3127 86.2169 82.7795Z",
    fill: "url(#paint26_linear_3647_7393)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2993 77.2331C92.6885 78.4703 94.5606 80.667 94.0015 84.1598C93.417 87.7956 92.0702 88.7635 90.7826 89.5631C89.4019 90.4215 84.9039 84.3786 84.9039 84.3786L56.8658 51.1761C56.8658 51.1761 83.2521 70.0372 91.2993 77.2331Z",
    fill: "url(#paint27_linear_3647_7393)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3314 70.8956C96.9154 71.8804 99.1432 73.7151 99.2025 77.25C99.2618 80.9279 98.1098 82.123 96.9747 83.133C95.7634 84.2103 90.2828 79.0342 90.2828 79.0342L56.8658 51.1761C56.8658 51.1761 86.1491 65.2062 95.3314 70.8956Z",
    fill: "url(#paint28_linear_3647_7393)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1945 63.9606C99.9225 64.6507 102.447 66.0815 103.116 69.549C103.819 73.168 102.887 74.5315 101.956 75.7266C100.948 76.9975 94.6453 72.8482 94.6453 72.8482L56.8658 51.1761C56.8658 51.1761 88.1567 59.9376 98.1945 63.9606Z",
    fill: "url(#paint29_linear_3647_7393)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7955 56.6384C101.625 57.0171 104.353 57.985 105.623 61.2926C106.945 64.7265 106.276 66.2414 105.556 67.5712C104.793 69.002 97.8557 65.9973 97.8557 65.9973L56.8658 51.1761C56.8658 51.1761 89.2155 54.408 99.7955 56.6384Z",
    fill: "url(#paint30_linear_3647_7393)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100.1 49.1398C101.972 49.2072 104.827 49.6869 106.648 52.7252C108.554 55.8813 108.156 57.4888 107.682 58.9196C107.174 60.4598 99.8209 58.7008 99.8209 58.7008L56.8658 51.1761C56.8658 51.1761 89.2833 48.7779 100.1 49.1398Z",
    fill: "url(#paint31_linear_3647_7393)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0924 41.7164C100.939 41.4555 103.836 41.4387 106.165 44.1151C108.597 46.8925 108.478 48.5421 108.266 50.0318C108.038 51.6393 100.49 51.1764 100.49 51.1764L56.8658 51.1761C56.8658 51.1761 88.3769 43.2145 99.0924 41.7164Z",
    fill: "url(#paint32_linear_3647_7393)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7969 34.5708C98.5757 33.9985 101.422 33.4851 104.183 35.7154C107.055 38.0299 107.233 39.6795 107.284 41.1861C107.343 42.802 99.8209 43.652 99.8209 43.652L56.8658 51.1761C56.8658 51.1761 86.5049 37.9037 96.7969 34.5708Z",
    fill: "url(#paint33_linear_3647_7393)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.29 27.9388C94.9333 27.0635 97.6524 26.062 100.761 27.7874C103.997 29.5716 104.463 31.1623 104.776 32.6352C105.107 34.2258 97.8557 36.3468 97.8557 36.3468L56.8658 51.1761C56.8658 51.1761 83.735 32.9886 93.29 27.9388Z",
    fill: "url(#paint34_linear_3647_7393)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6734 22.005C90.1473 20.8603 92.6462 19.4043 96.0091 20.5658C99.5075 21.7693 100.236 23.2506 100.804 24.6477C101.413 26.1542 94.6453 29.5039 94.6453 29.5039L56.8658 51.1761C56.8658 51.1761 80.1518 28.6286 88.6734 22.005Z",
    fill: "url(#paint35_linear_3647_7393)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0912 16.9639C84.3448 15.5836 86.5473 13.7152 90.0626 14.2791C93.722 14.8598 94.7046 16.1896 95.5008 17.4773C96.3648 18.8492 90.2828 23.3182 90.2828 23.3182L56.8658 51.1761C56.8658 51.1761 75.8572 24.9594 83.0912 16.9639Z",
    fill: "url(#paint36_linear_3647_7393)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7127 12.9578C77.7038 11.384 79.5504 9.16207 83.1081 9.11157C86.8183 9.05265 88.0127 10.1973 89.0292 11.3166C90.1134 12.5286 84.9039 17.974 84.9039 17.974L56.8658 51.1761C56.8658 51.1761 70.9865 22.0811 76.7127 12.9578Z",
    fill: "url(#paint37_linear_3647_7393)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7328 10.1131C70.4274 8.38776 71.8674 5.88808 75.3574 5.22319C78.9998 4.52463 80.3805 5.44204 81.5749 6.37625C82.854 7.37779 78.6779 13.6395 78.6779 13.6395L56.8658 51.1761C56.8658 51.1761 65.6838 20.0865 69.7328 10.1131Z",
    fill: "url(#paint38_linear_3647_7393)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3633 8.514C62.7444 6.69607 63.7186 3.98603 67.0476 2.72358C70.5036 1.41063 72.0284 2.08393 73.3668 2.7909C74.8068 3.55678 71.7827 10.4498 71.7827 10.4498L56.8658 51.1761C56.8658 51.1761 60.1185 19.0344 62.3633 8.514Z",
    fill: "url(#paint39_linear_3647_7393)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8237 8.21929C54.883 6.35927 55.3743 3.52295 58.4238 1.70502C61.6003 -0.180237 63.2182 0.21533 64.6582 0.678228C66.2084 1.18321 64.438 8.48859 64.438 8.48859L56.8653 51.1765C56.8653 51.1765 54.451 18.9585 54.8237 8.21929Z",
    fill: "url(#paint40_linear_3647_7393)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7131 0.106188C54.2137 -0.112637 52.5535 -0.222048 49.7581 2.18502C49.1991 2.67878 48.7445 3.18657 48.3943 3.70838C48.9873 5.83771 49.2922 8.48885 49.2922 8.48885L56.8653 51.1765L56.8651 7.83238C56.8651 7.83238 57.331 0.333429 55.7131 0.106188Z",
    fill: "url(#paint41_linear_3647_7393)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.606 51.1759C101.606 75.7264 81.573 95.631 56.8638 95.631C32.1546 95.631 12.1213 75.7264 12.1213 51.1759C12.1213 26.6255 32.1546 6.72084 56.8638 6.72084C81.573 6.72084 101.606 26.6255 101.606 51.1759Z",
    fill: "url(#paint42_linear_3647_7393)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.406 51.1765C97.406 73.4209 79.2532 91.4571 56.865 91.4571C34.4768 91.4571 16.324 73.4209 16.324 51.1765C16.324 28.9321 34.4768 10.8959 56.865 10.8959C79.2532 10.8959 97.406 28.9321 97.406 51.1765Z",
    fill: "url(#paint43_linear_3647_7393)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5909 51.176C96.5909 72.9743 78.8023 90.6486 56.8631 90.6486C34.9154 90.6486 17.1268 72.9743 17.1268 51.176C17.1268 29.3692 34.9154 11.6949 56.8631 11.6949C78.8023 11.6949 96.5909 29.3692 96.5909 51.176Z",
    fill: "url(#paint44_linear_3647_7393)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5576 51.1761C94.5576 71.8634 77.6839 88.6288 56.8628 88.6288C36.0417 88.6288 19.1595 71.8634 19.1595 51.1761C19.1595 30.4887 36.0417 13.715 56.8628 13.715C77.6839 13.715 94.5576 30.4887 94.5576 51.1761Z",
    fill: "url(#paint45_linear_3647_7393)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8652 51.1762C93.8652 71.4764 77.2964 87.9388 56.865 87.9388C36.4335 87.9388 19.8648 71.4764 19.8648 51.1762C19.8648 30.8676 36.4335 14.4136 56.865 14.4136C77.2964 14.4136 93.8652 30.8676 93.8652 51.1762Z",
    fill: "url(#paint46_linear_3647_7393)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9487 51.3024L56.9741 51.2772L56.9826 51.2603L56.9995 51.2351L57.0165 51.1846V51.1594L56.9995 51.1089L56.9826 51.0836L56.9741 51.0668L56.9233 51.0331L56.8979 51.0247H56.8217L56.7962 51.0331L56.7793 51.0499L56.7539 51.0668L56.7369 51.0836L56.7115 51.1594V51.1846L56.7369 51.2603L56.7793 51.3024L56.7962 51.3108L56.8471 51.3277H56.8725L56.9487 51.3024Z",
    fill: "#43AEBF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.191 53.8285V43.5016H35.1558C36.0537 43.5016 36.768 43.7177 37.2989 44.1497C37.8184 44.593 38.081 45.1653 38.0866 45.8666C38.081 46.4446 37.9229 46.9523 37.6123 47.39C37.2847 47.8276 36.8386 48.1362 36.2739 48.3158V48.341C36.9798 48.4252 37.5417 48.6917 37.9596 49.1406C38.3831 49.5782 38.5949 50.1534 38.5949 50.8659C38.5892 51.7525 38.273 52.4678 37.6462 53.0121C37.008 53.5563 36.2033 53.8285 35.232 53.8285H32.191ZM56.5359 25.0699L58.6282 31.4915L65.4217 31.4747L59.9242 35.4388L62.0334 41.8604L56.5359 37.8795L51.0469 41.8604L53.173 35.4388L47.6586 31.4747L54.4521 31.4915L56.5359 25.0699ZM73.3758 68.5655V58.2302H76.2558C79.9152 58.2358 81.7449 59.9163 81.7449 63.2716C81.7392 64.8651 81.2338 66.15 80.2286 67.1263C79.2065 68.0858 77.8455 68.5655 76.1457 68.5655H73.3758ZM74.5956 59.3243V67.4714H76.1372C77.5095 67.4714 78.5712 67.1067 79.3222 66.3772C80.0846 65.6534 80.463 64.6295 80.4573 63.3053C80.463 60.6513 79.0484 59.3243 76.2135 59.3243H74.5956ZM71.9357 68.5655H70.4872L68.7507 65.6703C68.5813 65.4066 68.4232 65.1765 68.2764 64.9801C68.1352 64.7894 67.9827 64.6379 67.819 64.5256C67.6552 64.3966 67.483 64.3068 67.3022 64.2563C67.1413 64.1974 66.9211 64.1806 66.7008 64.1806H65.6928V68.5655H64.49V58.2302H67.5818C68.0392 58.2302 68.4599 58.292 68.8439 58.4154C69.2279 58.522 69.5639 58.6903 69.8519 58.9204C70.123 59.1504 70.3433 59.4366 70.5127 59.7788C70.6708 60.1211 70.7499 60.5279 70.7499 60.9992C70.7499 61.3443 70.6905 61.6893 70.5804 61.9755C70.4731 62.2785 70.3207 62.545 70.123 62.775C69.9254 63.0163 69.6825 63.2183 69.3945 63.381C69.1122 63.5494 68.7931 63.6812 68.4373 63.7766V63.8018C68.618 63.8692 68.7705 63.959 68.8948 64.0712C69.019 64.1609 69.1432 64.276 69.2675 64.4162C69.3748 64.5509 69.4905 64.7024 69.6148 64.8707C69.7277 65.0334 69.8491 65.2326 69.979 65.4683L71.9357 68.5655ZM65.6928 59.3243V63.0949H67.3615C67.6609 63.0893 67.9404 63.0388 68.2001 62.9434C68.4543 62.8592 68.6745 62.7274 68.8609 62.5478C69.0585 62.3851 69.211 62.1775 69.3183 61.925C69.4143 61.6781 69.4623 61.4004 69.4623 61.0918C69.4623 60.5419 69.2844 60.1127 68.9286 59.8041C68.5729 59.4899 68.0505 59.33 67.3615 59.3243H65.6928ZM62.9398 68.5655H61.5845L60.4918 65.6787H56.0785L55.0536 68.5655H53.6982L57.671 58.2386H58.9331L62.9398 68.5655ZM60.0852 64.5762L58.4588 60.1744C58.3967 60.0341 58.3459 59.8041 58.3063 59.4843H58.2724C58.216 59.776 58.1623 60.0061 58.1115 60.1744L56.4766 64.5762H60.0852ZM53.8761 58.2302L50.9537 68.5655H49.5221L47.3791 61.016C47.2887 60.6962 47.2351 60.3427 47.2181 59.9556H47.1842C47.156 60.3203 47.0939 60.6654 46.9979 60.9908L44.8378 68.5655H43.4232L40.3907 58.2302H41.7206L43.9399 66.1584C44.0303 66.4895 44.0839 66.8373 44.1009 67.202H44.1432C44.1658 66.944 44.2449 66.5961 44.3804 66.1584L46.6675 58.2302H47.8365L50.0389 66.2173C50.1236 66.4923 50.1829 66.8121 50.2168 67.1768H50.2337C50.2591 66.9411 50.3269 66.5961 50.437 66.2005L52.5632 58.2302H53.8761ZM40.5686 68.5655H39.2133L38.1121 65.6703H33.6988L32.6569 68.5655H31.3016L35.2913 58.2302H36.5534L40.5686 68.5655ZM37.7139 64.5846L36.0876 60.1744C36.0311 60.0341 35.9746 59.8041 35.9181 59.4843H35.8843C35.8504 59.7816 35.7967 60.0117 35.7233 60.1744L34.1054 64.5846H37.7139ZM72.5033 53.8285V43.5016H75.3749C79.0399 43.496 80.8724 45.1737 80.8724 48.5346C80.8667 50.1281 80.3585 51.4158 79.3476 52.3977C78.3255 53.3572 76.9646 53.8341 75.2648 53.8285H72.5033ZM73.7315 44.5874V52.7428H75.2732C76.6455 52.7372 77.7071 52.3725 78.4582 51.6487C79.2206 50.9248 79.5989 49.9009 79.5933 48.5767C79.5933 45.9171 78.1759 44.5874 75.341 44.5874H73.7315ZM69.2336 53.8285H67.7258L62.3808 45.5889C62.2396 45.3869 62.1238 45.1737 62.0334 44.9493H61.9996C62.0335 45.1681 62.0504 45.6422 62.0504 46.3716V53.8285H60.8475V43.5016H62.4231L67.6157 51.615C67.8416 51.9404 67.9827 52.1705 68.0392 52.3051H68.0816C68.0251 52.0134 67.9997 51.5028 68.0053 50.7733V43.5016H69.2336V53.8285ZM58.7383 53.8285H57.3999L56.3072 50.9333H51.894L50.8521 53.8285H49.4967L53.4865 43.4932H54.7486L58.7383 53.8285ZM55.9006 49.8476L54.2488 45.4458C54.2093 45.2943 54.1613 45.0643 54.1048 44.7557H54.0709C54.0314 45.0474 53.9749 45.2775 53.9015 45.4458L52.2921 49.8476H55.9006ZM48.709 53.8285H47.2605L45.524 50.9417C45.3546 50.6639 45.2105 50.4451 45.0496 50.2431C44.9028 50.058 44.7503 49.9065 44.5922 49.7886C44.4284 49.6652 44.2562 49.5754 44.0755 49.5193C43.9145 49.4604 43.6943 49.4436 43.474 49.4436H42.466V53.8285H41.2547V43.4932H44.355C44.8124 43.4932 45.2331 43.5549 45.6171 43.6784C45.9955 43.785 46.3287 43.9561 46.6167 44.1918C46.8934 44.4218 47.1136 44.7052 47.2774 45.0418C47.4412 45.3841 47.5202 45.7909 47.5146 46.2622C47.5146 46.6073 47.4638 46.9523 47.3536 47.2469C47.2463 47.5499 47.0939 47.8164 46.8962 48.0465C46.6986 48.2821 46.4529 48.4813 46.1593 48.644C45.8826 48.8067 45.5663 48.9358 45.2105 49.0312V49.0648C45.3913 49.1378 45.5437 49.2219 45.668 49.3173C45.7922 49.4239 45.9136 49.5446 46.0322 49.6792C46.1395 49.8027 46.2553 49.9542 46.3795 50.1337C46.4925 50.302 46.6167 50.504 46.7522 50.7397L48.709 53.8285ZM42.466 44.5874V48.3326H44.1263C44.4256 48.3382 44.7079 48.2961 44.9734 48.2064C45.2275 48.1166 45.4449 47.9819 45.6256 47.8024C45.8289 47.6341 45.9842 47.4293 46.0915 47.188C46.1819 46.9355 46.2299 46.655 46.2355 46.3464C46.2299 45.8021 46.052 45.3729 45.7019 45.0587C45.3404 44.7445 44.8152 44.5874 44.1263 44.5874H42.466ZM33.4023 44.5874V47.937H34.6475C35.3139 47.9314 35.8391 47.7715 36.2231 47.4573C36.6071 47.1319 36.7963 46.6774 36.7906 46.0939C36.7963 45.0895 36.1327 44.5874 34.8 44.5874H33.4023ZM33.4023 49.0228V52.7344H35.0457C35.7572 52.74 36.3134 52.5688 36.7144 52.221C37.0984 51.8899 37.2932 51.4298 37.2989 50.8407C37.2932 49.6287 36.4574 49.0228 34.7915 49.0228H33.4023Z",
    fill: "#575757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3647_7393",
    x1: -114.515,
    y1: 105.709,
    x2: -83.1832,
    y2: -9.06243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3647_7393",
    x1: -114.515,
    y1: 105.709,
    x2: -83.1832,
    y2: -9.06243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3647_7393",
    x1: -67.5952,
    y1: 207.529,
    x2: -119.386,
    y2: 41.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3647_7393",
    x1: -67.5952,
    y1: 207.529,
    x2: -119.386,
    y2: 41.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3647_7393",
    x1: -101.679,
    y1: 117.558,
    x2: -100.191,
    y2: 41.3419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3647_7393",
    x1: -101.694,
    y1: 119.125,
    x2: -100.206,
    y2: 42.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3647_7393",
    x1: 137.407,
    y1: 186.875,
    x2: 75.5531,
    y2: 215.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3647_7393",
    x1: 134.623,
    y1: 185.284,
    x2: 92.3005,
    y2: 209.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3647_7393",
    x1: 132.938,
    y1: 183.446,
    x2: 98.2656,
    y2: 204.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3647_7393",
    x1: 131.716,
    y1: 181.159,
    x2: 99.4579,
    y2: 202.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3647_7393",
    x1: 130.697,
    y1: 178.062,
    x2: 97.123,
    y2: 201.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3647_7393",
    x1: 129.749,
    y1: 173.207,
    x2: 90.2326,
    y2: 201.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3647_7393",
    x1: 128.842,
    y1: 163.894,
    x2: 73.4637,
    y2: 205.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3647_7393",
    x1: 127.958,
    y1: 109.398,
    x2: 39.6245,
    y2: 210.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3647_7393",
    x1: 127.058,
    y1: -45.9884,
    x2: 195.889,
    y2: 117.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3647_7393",
    x1: 126.09,
    y1: -37.6966,
    x2: 181.582,
    y2: 17.3503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3647_7393",
    x1: 125.015,
    y1: -33.5532,
    x2: 165.393,
    y2: -0.86232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3647_7393",
    x1: 123.775,
    y1: -31.056,
    x2: 157.701,
    y2: -6.09099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3647_7393",
    x1: 122.235,
    y1: -29.239,
    x2: 154.263,
    y2: -7.01071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3647_7393",
    x1: 120.145,
    y1: -27.725,
    x2: 153.847,
    y2: -5.32515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3647_7393",
    x1: 116.867,
    y1: -26.3245,
    x2: 156.937,
    y2: -0.73115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3647_7393",
    x1: 110.579,
    y1: -24.9774,
    x2: 167.583,
    y2: 9.34526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3647_7393",
    x1: 73.7961,
    y1: -23.6671,
    x2: 177.518,
    y2: 17.7815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3647_7393",
    x1: -31.0073,
    y1: -22.3307,
    x2: 93.9982,
    y2: -46.3303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3647_7393",
    x1: -25.4231,
    y1: -20.8977,
    x2: 36.4333,
    y2: -49.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3647_7393",
    x1: -22.6349,
    y1: -19.3045,
    x2: 19.6836,
    y2: -43.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3647_7393",
    x1: -20.9527,
    y1: -17.4646,
    x2: 13.7288,
    y2: -38.9148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3647_7393",
    x1: -19.725,
    y1: -15.1839,
    x2: 12.5359,
    y2: -36.3397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3647_7393",
    x1: -18.706,
    y1: -12.0805,
    x2: 14.8714,
    y2: -35.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3647_7393",
    x1: -17.7577,
    y1: -7.23001,
    x2: 21.7617,
    y2: -35.3931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3647_7393",
    x1: -16.8503,
    y1: 2.07303,
    x2: 38.5306,
    y2: -39.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3647_7393",
    x1: -15.9644,
    y1: 56.6543,
    x2: 72.3669,
    y2: -44.0305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3647_7393",
    x1: -15.0643,
    y1: 211.908,
    x2: -83.8512,
    y2: 48.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3647_7393",
    x1: -14.0959,
    y1: 203.645,
    x2: -69.576,
    y2: 148.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3647_7393",
    x1: -13.0188,
    y1: 199.525,
    x2: -53.393,
    y2: 166.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3647_7393",
    x1: -11.7791,
    y1: 197.033,
    x2: -45.703,
    y2: 172.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3647_7393",
    x1: -10.2397,
    y1: 195.218,
    x2: -42.2693,
    y2: 172.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3647_7393",
    x1: -8.15072,
    y1: 193.708,
    x2: -41.853,
    y2: 171.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3647_7393",
    x1: -4.87809,
    y1: 192.304,
    x2: -44.9427,
    y2: 166.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3647_7393",
    x1: 1.40428,
    y1: 190.957,
    x2: -55.5972,
    y2: 156.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3647_7393",
    x1: 38.1859,
    y1: 189.65,
    x2: -65.5337,
    y2: 148.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3647_7393",
    x1: 147.607,
    y1: 191.635,
    x2: -0.808708,
    y2: 224.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3647_7393",
    x1: 0,
    y1: -0.00157316,
    x2: 111.997,
    y2: -0.00157316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3647_7393",
    x1: 0,
    y1: -0.00173144,
    x2: 111.996,
    y2: -0.00173144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3647_7393",
    x1: 3.65454,
    y1: 195.944,
    x2: -45.8751,
    y2: 11.0356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3647_7393",
    x1: 0.00629294,
    y1: 166.744,
    x2: -1.36468,
    y2: -0.876013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3647_7393",
    x1: 240.182,
    y1: -2.66404,
    x2: -146.664,
    y2: 229.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEE64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79416"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/Award.c80aabd0e59edd84f1d321f54ec39c78.svg";
export { ForwardRef as ReactComponent };